$(function(){
    $(".go_v").click(function(){
        $('html,body').stop(true, false).animate({ scrollTop: $(".form").offset().top }, 0);
    });
});